"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NOTIFIED_ORDER_STATUS = exports.EDITABLE_ORDER_STATUS = exports.VALID_INITIAL_ORDER_STATUS = exports.RESERVATION_ORDER_SALES_PREFIX = exports.ONLINE_ORDER_SALES_PREFIX = void 0;
const orders_1 = require("../enums/orders");
exports.ONLINE_ORDER_SALES_PREFIX = 'OL';
exports.RESERVATION_ORDER_SALES_PREFIX = 'OR';
exports.VALID_INITIAL_ORDER_STATUS = [
    orders_1.OrderStatus.DRAFT,
    orders_1.OrderStatus.CREATED,
];
exports.EDITABLE_ORDER_STATUS = [
    orders_1.OrderStatus.DRAFT,
    orders_1.OrderStatus.CREATED,
    orders_1.OrderStatus.IN_PROGRESS,
    orders_1.OrderStatus.ON_HOLD,
    orders_1.OrderStatus.ON_ACCOUNT,
];
exports.NOTIFIED_ORDER_STATUS = [
    orders_1.OrderStatus.IN_PROGRESS,
    orders_1.OrderStatus.COMPLETED,
];
//# sourceMappingURL=orders.js.map